import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Badge, BadgeContainer } from "@progress/kendo-react-indicators";
import { uploadIcon } from "@progress/kendo-svg-icons";
import { useWorkspaceContextStore } from "@presentation/stores/WorkspaceContextStore";
import { useProjectPermission } from "./usePermissionCheck";
import { ProjectActions } from "@domain/schemas/workspace";

interface UploadButtonProps {
  onClick: () => void;
  title: string;
  uploadingCount?: number;
  projectId?: string;
}

export const UploadButton: React.FC<UploadButtonProps> = ({ onClick, title, uploadingCount = 0, projectId }) => {
  const activeProjectId = useWorkspaceContextStore((state) => state.activeProjectId);
  const { allowed } = useProjectPermission(projectId ?? activeProjectId, ProjectActions.TriggerJob);
  return (
    <BadgeContainer>
      <Button type="button" svgIcon={uploadIcon} onClick={onClick} disabled={!allowed} title={allowed ? title : "You do not have permission to upload files in this project."}>
        Upload
      </Button>
      {uploadingCount > 0 && (
        <Badge themeColor="primary" size="small" align={{ vertical: "top", horizontal: "end" }}>
          {uploadingCount}
        </Badge>
      )}
    </BadgeContainer>
  );
};
